import React from 'react';
import styled from 'styled-components';

const ViewButton = styled.button`
  font-family: Arial, Helvetica, sans-serif;
  background-color: transparent;
  color: #ccc;
  border: none;
  border-radius: 5px;
  padding: 8px 16px;
  cursor: pointer;
  transition: color 0.3s ease;

  span {
    color: #aca; 
  }

  &:focus {
    outline: none;
  }

  &:hover {
  }
`;

function Views({ children }) {
  return (
    <ViewButton>
      Views: &nbsp;
      <span>{children}</span>
    </ViewButton>
  );
}

export default Views;
